import { render, staticRenderFns } from "./VideoEntity.vue?vue&type=template&id=00abb618&scoped=true"
import script from "./VideoEntity.vue?vue&type=script&lang=js"
export * from "./VideoEntity.vue?vue&type=script&lang=js"
import style0 from "./VideoEntity.vue?vue&type=style&index=0&id=00abb618&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00abb618",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00abb618')) {
      api.createRecord('00abb618', component.options)
    } else {
      api.reload('00abb618', component.options)
    }
    module.hot.accept("./VideoEntity.vue?vue&type=template&id=00abb618&scoped=true", function () {
      api.rerender('00abb618', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/VideoEntity.vue"
export default component.exports